import { useMutation, useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { useToast } from 'components/hooks/useToast';
import { useDispatch } from 'react-redux';
import {
  setReviewMetaData,
  useReviewCreationData,
  useReviewTypeAndDetails,
  setReviewCycleId,
  setReviewTypeAndDetails,
} from 'reducers/reviewCreationSlice';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { useReviewCreationNavigation } from '../useReviewCreationNavigation';

const getReviewTypeAndDetails = ({ reviewCycleId }) => {
  const url = endpoints.reviews.reviewCycleCreation.reviewTypeAndDetails;

  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      review_cycle_id: reviewCycleId,
    },
  });
};

const putReviewTypeAndDetails = ({ reviewCycleId, name, description, startDate, endDate }) => {
  const url = endpoints.reviews.reviewCycleCreation.reviewTypeAndDetails;

  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      id: reviewCycleId,
      name,
      description,
      startDate,
      endDate,
    },
  });
};

export const useGetReviewTypeAndDetails = ({ reviewCycleId }) => {
  const dispatch = useDispatch();
  return useQuery(
    [REACT_QUERY_KEYS.reviewCreation.NAME],
    () =>
      getReviewTypeAndDetails({ reviewCycleId }).then((res) => {
        const { name, description, startDate, endDate, currentStage, lastEnabledSection } = res.entity;
        dispatch(setReviewTypeAndDetails({ name, description, startDate, endDate }));
        dispatch(setReviewMetaData({ currentStage, lastEnabledSection }));
        return res.entity;
      }),

    { enabled: !!reviewCycleId }
  );
};

export const useSaveReviewTypeAndDetails = () => {
  const toast = useToast();
  // const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { goToNextStep, goToStep } = useReviewCreationNavigation();

  const { reviewCycleId } = useReviewCreationData();
  const { name, description, startDate, endDate } = useReviewTypeAndDetails();

  return useMutation({
    mutationFn: () =>
      putReviewTypeAndDetails({
        reviewCycleId,
        name,
        description,
        startDate,
        endDate,
      }),
    onSuccess: (data, variables) => {
      dispatch(setReviewCycleId(data.entity));
      // todo: navigate to next step
      if (variables?.nextStep) {
        goToStep(variables.nextStep);
        return;
      }
      goToNextStep({ reviewCycleIdFromApi: data.entity });
      // --------------------------------
      // queryClient.invalidateQueries([REACT_QUERY_KEYS.views.views]);
      // queryClient
      //   .invalidateQueries([REACT_QUERY_KEYS.views.sidebarViewCohorts, module])
      //   .then(() => {
      //     applyFilters(history, location, data);
      //   });
      // // applyFilters(history, location, data);
      // dispatch(setSaveViewErrorMessage(null));
      // dispatch(setIsSaveViewModalOpen(false));
      // // dispatch(setViewsSubScreen(null));
    },
    onError: (error) => {
      const errorMessage = error.body?.message;
      toast({ title: errorMessage, status: 'error' });
      if (errorMessage) {
        dispatch(setReviewTypeAndDetails({ name: '' }));
      }
    },
  });
};
